import { render, staticRenderFns } from "./validation-editor.vue?vue&type=template&id=66f28e28&scoped=true&"
import script from "./validation-editor.vue?vue&type=script&lang=js&"
export * from "./validation-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f28e28",
  null
  
)

export default component.exports